export default "__VITE_ASSET__c229e9a0__"